module.exports = __webpack_public_path__ + "static/media/image-card-10.d6c582d0.png";